import type { OperatorBookingSettingsData } from "api-client";

export interface BookingSettingsState {
  data: OperatorBookingSettingsData | null;
  loading: boolean;
  error: string | null;
  saving: boolean;
  saveError: string | null;
}

export const bookingSettingsInitialState: BookingSettingsState = {
  data: null,
  loading: false,
  error: null,
  saving: false,
  saveError: null,
};
